import React, {useState, useRef, useEffect} from 'react'
import { useReactToPrint } from 'react-to-print';
import impresora from '../images/impresora.png'
import factura from '../images/factura.png'
import {Actualizar} from './dbfirebase'
import ServicesPostventaLogo from '../images/ServicesPostventaLogo.PNG'
import QRGenerator from './QRGenerator';
import { SlackErrorHandle } from '../components/SlackErrorMsj'
import garantiaImage from '../images/GARANTIA.PNG';
import facturableImage from '../images/Facturable.PNG';
import { useSelector } from 'react-redux';

export const OrdenModal = (documentInfo, handleUpdate) =>{
    
    const [pages, setPages] = useState([0])
    const [indice, setIndice] = useState()
    const [document, setDocument] = useState({
        Fecha: '-',
        ID: '-',
        Titular: '-',
        Taller: '-',
        Direccion: '-',
        Telefono: '-',
        Email: '-',
        Cliente: '-',
        Domicilio_cli: '-',
        CuitDni_cli: '-',
        Telefono_cli: '-',
        Email_cli: '-',
        Categoria: '-',
        Articulo: '-',
        Tipo: '-',
        Desperfecto: '-',
        Desperfecto_declarado: '-',
        Comentarios: '-',
        Garantia: '-',
        NumFactura: '-',
        RazonSocialCli: '-',
        FechaCompra: '-',
        Repuestos: '-',
        ConformeCierreURL: '',
        Num_Serie: '-',
        Num_Os: '-',
        Localidad:'-',
        Localidad_cli:'-',
        Provincia_cli:'-',
        Provincia:'-',
        CodigoPostal: '-',
        Transporte: '-',
        piso: '-'
    })
    
    const orders = useSelector(state => state.ordersInfo)
    const ordenes_modificadas = orders.filter((item) => item.Modificaciones && item.iddoc === documentInfo.data.iddoc)
    const originalOrder = orders.filter((item) => item.iddoc === documentInfo.data.iddoc)
    
    const handleClick = (index) => {
        
        let fuenteDatos;
        if (index === 0) {
            fuenteDatos = ordenes_modificadas[0].Modificaciones[index]
            setIndice(index)
        } else if (index === ordenes_modificadas[0].Modificaciones.length) {
            fuenteDatos = originalOrder[0];
            setIndice(index)
        } else {
            fuenteDatos = ordenes_modificadas[0].Modificaciones[index];    
            setIndice(index)
        }
        const datos = {
            Fecha: fuenteDatos.Fecha,
            ID: fuenteDatos.iddoc,
            Titular: fuenteDatos.Titular,
            Taller: fuenteDatos.Taller,
            Direccion: fuenteDatos.Direccion,
            Telefono: fuenteDatos.Telefono,
            Email: fuenteDatos.Email,
            Cliente: fuenteDatos.Cliente,
            Domicilio_cli: fuenteDatos.Domicilio_cli,
            CuitDni_cli: fuenteDatos.CuitDni_cli,
            Telefono_cli: fuenteDatos.Telefono_cli,
            Email_cli: fuenteDatos.Email_cli,
            Categoria: fuenteDatos.Categoria,
            Articulo: fuenteDatos.Articulo,
            Tipo: fuenteDatos.Tipo,
            Desperfecto: fuenteDatos.Desperfecto,
            Desperfecto_declarado: fuenteDatos.Desperfecto_declarado,
            Comentarios: fuenteDatos.Comentarios,
            Garantia: fuenteDatos.Garantia,
            NumFactura: fuenteDatos.NumFactura,
            RazonSocialCli: fuenteDatos.RazonSocialCli,
            FechaCompra: fuenteDatos.FechaCompra,
            Repuestos: fuenteDatos.Repuestos || [],
            MotivoCierre: fuenteDatos.MotivoCierre,
            ConformeCierreURL: fuenteDatos.ConformeCierreURL || '',
            Num_Serie: fuenteDatos.Num_Serie,
            Num_Os: fuenteDatos.Num_Os,
            Localidad_cli: fuenteDatos.Localidad_cli,
            Provincia_cli: fuenteDatos.Provincia_cli,
            CodigoPostal_cli: fuenteDatos.CodigoPostal_cli,
            Transporte_cli: fuenteDatos.Transporte_cli,
            PisoDept_cli: fuenteDatos.PisoDept_cli,
            FechaModificacion: fuenteDatos.FechaModificacion,
            
        };

        setDocument(datos);
        
    };
    
    useEffect(() =>{
        if (documentInfo.data.Id && documentInfo.data.FechaModificacion){
            const modificacionesLength = ordenes_modificadas[0].Modificaciones.length;

            // Generar un array con un rango desde 1 hasta modificacionesLength
            const rangeArray = Array.from({ length: modificacionesLength }, (_, index) => index + 1);
            setPages([...pages, ...rangeArray])
        }
        setDocument(documentInfo.data)
    },[documentInfo.data])
    

    const OrderRef = useRef(null)

    const handlePrint = useReactToPrint({
        content: () => OrderRef.current,
        },
    );

    const qrData = 'https://atencion.peabody.com.ar/'

    const closeModal = () => {
        const modal = document.getElementById('Modal');
        const backdrop = document.querySelector('.modal-backdrop');
        
        if(OrderRef.current.classList.contains('show')){           
            modal.classList.remove('show');
            modal.style.display = 'none'
            document.body.classList.remove('modal-open');
            modal.classList.add('show');
        }
        if (backdrop) {
            backdrop.remove();
        }
        document.body.style.overflow = 'auto';
    };

    const handleCloseModal = () => {
         closeModal();
    };

     window.history.pushState({}, '', '');

    useEffect(() => {

        const handlePopstate = () => {
            if (OrderRef.current.classList.contains('show')) {
                closeModal()
            }
        };
      
        window.addEventListener('popstate', handlePopstate);
      
        return () => {
          
            window.removeEventListener('popstate', handlePopstate);
        };
        
    },[]);
    
    return(
        <div className="modal"
                id="Modal"
                tabIndex={-1}
                aria-labelledby="Modal"
                aria-hidden="true"
                style={{marginBottom:'20px' ,marginTop:'20px', overflow: "auto"}} >
        <div className="modal-dialog modal-fullscreen-lg-down modal-lg" ref={OrderRef}>
        
        {/* <div className='container modal-content' > style={{ overflow: "auto" }} */}
        <div className='container modal-content' >
            <div className='row' style={{marginTop:'15px'}}>
                 <div className='col-6 d-flex justify-content-start'> 
                    <img src={ServicesPostventaLogo} width="210" height="60"></img>
                </div>
                <div className='col-6 d-flex justify-content-end'>
                    {/* <button type="button" className='btn-close' onClick={()=>handleCloseModal()}></button> */}
                    {documentInfo.data.FechaModificacion &&
                        <p className='d-flex justify-content-start'>{indice === 0?'Documento original.':`Modificado el: ${document.FechaModificacion}`}</p>
                    }
                </div>
            </div>
            
            <div className="row">   
                <p className='d-flex justify-content-end'>Fecha: {document.Fecha}</p>   
            </div>
            {/* Titulo y ID documento */}
            <div className="row" style={{marginBottom:'15px'}}>
                <div className='col-6 d-flex justify-content-start'>
                    
                    <h3>Orden de servicio</h3>
                </div>
                <div className='col-6 d-flex justify-content-end'>
                    <p>ID: {document.ID || document.iddoc}</p>
                </div>
            </div>
            {/* Datos taller y boton imprimir */}
            <div style={{borderBottom: '1px solid', width:'100%',marginBottom:'20px', borderBottomColor:'#bcbcbc'}}>
                <div className="row">
                    <p className='col-6 d-flex mb-1'>Responsable: {document.Titular}</p>
                    <p className='col-6 d-flex mb-1'>Razon social: {document.Taller}</p>
                    <p className='col-6 d-flex mb-1'>Domicilio: {document.Direccion}</p>
                    <p className='col-6 d-flex mb-1'>Telefono: {document.Telefono}</p>
                    <p className='col-6 d-flex mb-1'>E-mail: {document.Email}</p>
                </div>
                <div className="row" style={{marginBottom:'20px'}}>
                    <div className='col-12 d-flex justify-content-end d-print-none'>
                        <button style={{border:'none',backgroundColor: '#ffffff'}} onClick={() => {
                                                                                                    try {
                                                                                                        handlePrint();
                                                                                                    } catch (error) {
                                                                                                        SlackErrorHandle(`${new Date()}: service.peadoby.com.ar -> Error en impresion de la orden -> ${error}`);
                                                                                                    }
                                                                                                    }}>
                            <label style={{margin:'0 20px'}}>Imprimir</label>
                            <img src={impresora} width='50rem' height='50rem' alt=''/>
                        </button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='col-12 d-flex justify-content-start' style={{marginBottom:'10px'}}>
                    <h4>Datos del cliente:</h4>
                </div>
          
                <form style={{marginBottom:'10px'}}>
                    <div className="row" style={{borderBottom: '1px solid',borderBottomColor:'#bcbcbc'}}> 
                      
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Nombre:</label>
                                <label style={{margin:'0 1rem',minWidth:'5rem'}}>{document.Cliente}</label>
                                
                            </div>
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Domicilio:</label>
                                <label style={{margin:'0 1rem',minWidth:'5rem'}}>{document.Domicilio_cli}</label>
                                
                            </div>
                   
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Cuit/Dni:</label>
                                <label style={{margin:'0 1rem',minWidth:'5rem'}}>{document.CuitDni_cli}</label>
                                
                            </div>
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Telefono:</label>
                                <label style={{margin:'0 1rem',minWidth:'5rem'}}>{document.Telefono_cli}</label>
                                
                            </div>
                                          
                            <div className='col-6 d-flex mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>E-mail:</label>
                                <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.Email_cli}</label>
                               
                            </div>

                            <div className='col-6 d-flex mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Localidad:</label>
                                <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.Localidad_cli}</label>
                               
                            </div>

                            <div className='col-6 d-flex mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Provincia:</label>
                                <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.Provincia_cli}</label>
                               
                            </div>
                            <div className='col-6 d-flex mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Codigo postal:</label>
                                <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.CodigoPostal_cli}</label>
                               
                            </div>
                            <div className='col-6 d-flex mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Transporte:</label>
                                <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.Transporte_cli}</label>
                               
                            </div>
                            <div className='col-6 d-flex mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Piso/Dto:</label>
                                <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.PisoDept_cli}</label>
                               
                            </div>
                    </div>           
                </form>
            </div>
            <div className="row">
                
                <div className='col-6 d-flex justify-content-start'style={{marginBottom:'10px'}}>
                    <h4>Datos del producto:</h4>
                </div>
                <div className='col-6 d-flex justify-content-end'>
                    {document.Garantia? <img className="imagen" style={{zIndex:0}} src={garantiaImage} alt="garantia"/>:
                                    <img className="imagen" style={{zIndex:0}} src={facturableImage} alt="facturable"/>}
                </div>
                <div className='col-6 d-flex ms-1 mb-4' style={{alignItems: 'center' }}>
                    <label className="fw-bold" style={{margin:'0 0.2rem'}}>En garantía:</label>
                    <label style={{margin:'0 0.2rem'}}>{document.Garantia?'SI':'NO'}</label>
                    
                </div>
               
                {document.Garantia && <div className="row"> 
                                <div className='col-6 d-flex ms-auto mb-3'>
                                    <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Numero de factura:</label>
                                    <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.NumFactura}</label>
                                </div>
                                <div className='col-6 d-flex ms-auto mb-3'>
                                    <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Razon Social:</label>
                                    <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.RazonSocialCli}</label>
                                </div>
                                <div className='col-6 d-flex ms-auto mb-3'>
                                    <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Fecha:</label>
                                    <label style={{margin:'0 1rem', minWidth:'5rem'}}>{document.FechaCompra}</label>
                                </div>
                            </div>
                            }
               
                    
              
               <form style={{marginBottom:'10px'}}>
                    <div className="row" style={{borderBottom: '1px solid', width:'100%',borderBottomColor:'#bcbcbc'}}> 
                       
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Categoria:</label>
                                <label style={{minWidth:'5rem'}}>{document.Categoria}</label>
                            
                            </div>
                            
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Articulo:</label>
                                <label style={{minWidth:'5rem'}}>{document.Articulo}</label>
                            </div>
                   
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Tipo:</label>
                                <label style={{minWidth:'5rem'}}>{document.Tipo}</label>
                            </div>
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Numero de serie:</label>
                                <label style={{minWidth:'5rem'}}>{document.Num_Serie}</label>
                            </div>
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Numero de orden:</label>
                                <label style={{minWidth:'5rem'}}>{document.Num_Os}</label>
                            </div>
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Mtv. devolucion:</label>
                                <label style={{minWidth:'5rem'}}>{document.Desperfecto}</label>
                                
                            </div>
                            <div className='col-6 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem'}}>Falla declarada:</label>
                                <label style={{minWidth:'5rem'}}>{document.Desperfecto_declarado}</label>
                                
                            </div>
                                        
                            <div className='col-6 d-flex mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem', minWidth:'5rem'}}>Observacion:</label>
                                <label style={{minWidth:'5rem'}}>{document.Comentarios}</label>
                                
                            </div>
                    </div>
                    <div className="row" style={{borderBottom: '1px solid', width:'100%',borderBottomColor:'#bcbcbc'}}> 
                            <h4>Repuestos:</h4>
                            
                            <label className="fw-bold" style={{margin:'0 1rem',minWidth:'5rem', marginBottom:'10px'}}>Repuestos solicitados:</label>
                            <div className='col-12 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                            
                            <ul>
                                {document.Repuestos && Array.isArray(document.Repuestos) ? (document.Repuestos.map((repuesto, index) => (
                                <li key={index}>{repuesto.Descripcion +' ('+ repuesto.UltEstado +')'}</li>
                                ))
                                ) : (
                                    <li>No hay repuestos solicitados</li>
                                    )}
                            </ul>
                            
                            </div>
                    </div>               
                </form>
                {/* <div className="row">*/}
                    
                    <div className='row d-flex justify-content-start' style={{marginBottom:'10px', alignItems: 'center'}}>
                        <h4>Estado de la orden:</h4>
                       
                        <label className="fw-bold" style={{margin:'0 1rem', marginBottom:'10px'}}>{document.Estado}</label>
                        <div className=' col-12 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                           
                            <label style={{margin:'0 1rem', maxWidth: '45rem'}}>
                                {Array.isArray(document.MotivoCierre) ? (
                                    document.MotivoCierre.map((motivo, index) => (
                                    <li key={index}>{motivo}</li>
                                    ))
                                ) : (
                                    <li>No hay motivos de cierre disponibles</li>
                                )}
                            </label>
                        </div>
                        {document.ConformeCierreURL ? (
                            <div className=' col-12 d-flex ms-auto mb-3' style={{alignItems: 'center' }}>
                                <label className="fw-bold" style={{margin:'0 1rem'}}>Conforme de cierre:</label>
                                <a href={document.ConformeCierreURL} target="_blank" rel="noreferrer">Ver archivo adjunto</a>
                            </div>
                        ) : null}
                        {documentInfo.data.FechaModificacion && pages &&
                            <div className="row d-print-none" style={{marginTop:'15px'}}>
                                <nav aria-label="...">
                                    <div className="row">
                                        <div className="col-6 d-flex justify-content-end">
                                            <p>Versiones:</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start">
                                            <ul className="pagination pagination-sm d-flex justify-content-start">
                                            
                                                {pages.map((page, index) => (
                                                    <li className="page-item" key={index}>
                                                        <button className="page-link" onClick={() => handleClick(index)}>
                                                            {page}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                                <p className='d-flex justify-content-end'>{indice === 0?'Documento original.':`Modificado el: ${document.FechaModificacion}`}</p>
                            </div>
                        }

                        {/* <div className="btn-group dropright" style={{margin:'0 1rem'}}>
                            <button type="button" className="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Estado de documento
                            </button> 
                            <div className="dropdown-menu">
                                <button className="dropdown-item" onClick={() =>actualizar('Repuestos')}>En espera de repuestos solicitados</button>
                                <button className="dropdown-item" onClick={() =>actualizar('Reparando')}>En proceso de reparacion</button>
                                <button className="dropdown-item" onClick={() =>actualizar('Finalizado')}>Reparacion Finalizada</button>    
                            </div>
                        </div>  */}
                    </div> 
                   {/*   <div className='col-12 d-flex justify-content-end image-upload d-print-none'style={{marginBottom:'20px'}}>
                            <label htmlFor='photo'>Adjuntar fotos:    
                                <img src={camara} width='50rem' height='50rem' alt='' style={{margin:'0 0 0 20px'}}/>
                            </label>
                            <input type="file" accept="image/*" capture id='photo' onChange={getimage}></input>
                    </div>*/}
                {/*   <div className='card-body col-12 d-flex justify-content-start d-print-none' style={{ overflowX: "auto",marginBottom:'20px' }}>
                    
                        <table className="table table-hover table-responsive-sm table-bordered" ref={refrepuestos}>
                            <thead className = 'table-dark'>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Repuesto</th>
                                    <th>Descripcion</th>
                                    <th>Cantidad</th>
                                    <th>Falla</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{width: '5rem'}}>{date1}</td>
                                    <td style={{width: '15rem'}}>
                                        <select value={selectedOption1} onChange={handleTypeSelect1} style={{ border: 'none', width: '10rem'}}>
                                            <option value="">-- Seleccionar --</option>
                                            {options.map((option) => (
                                            <option key={option.value} value={option.value} id='first-column1'>
                                                {option.value}
                                            </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td style={{width: '20rem'}}>{descripcion1}</td>
                                    <td style={{width: '15rem'}}><input type="text" name="campo1" style={{ border: 'none', width: '4rem'}}/></td>
                                    <td style={{width: '15rem'}}><input type="text" name="campo1" style={{ border: 'none', width: '15rem' }}/></td>
                                </tr>
                                <tr>
                                    <td style={{width: '5rem'}}>{date2}</td>
                                    <td style={{width: '15rem'}}>
                                        <select value={selectedOption2} onChange={handleTypeSelect2} style={{ border: 'none', width: '10rem'}}>
                                            <option value="">-- Seleccionar --</option>
                                            {options.map((option) => (
                                            <option key={option.value} value={option.value} id='first-column2'>
                                                {option.value}
                                            </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td style={{width: '20rem'}}>{descripcion2}</td>
                                    <td style={{width: '15rem'}}><input type="text" name="campo1" style={{ border: 'none', width: '4rem'}}/></td>
                                    <td style={{width: '15rem'}}><input type="text" name="campo1" style={{ border: 'none', width: '15rem'}}/></td>
                                </tr>
                                <tr>
                                    <td style={{width: '5rem'}}>{date3}</td>
                                    <td style={{width: '15rem'}}>
                                        <select value={selectedOption3} onChange={handleTypeSelect3} style={{ border: 'none', width: '10rem'}}>
                                            <option value="">-- Seleccionar --</option>
                                            {options.map((option) => (
                                            <option key={option.value} value={option.value} id='first-column3'>
                                                {option.value}
                                            </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td style={{width: '20rem'}}>{descripcion3}</td>
                                    <td style={{width: '15rem'}}><input type="text" name="campo1" style={{ border: 'none', width: '4rem'}}/></td>
                                    <td style={{width: '15rem'}}><input type="text" name="campo1" style={{ border: 'none', width: '15rem' }}/></td>
                                </tr>
                                <tr>
                                    <td style={{width: '5rem'}}>{date4}</td>
                                    <td style={{width: '15rem'}}>
                                        <select value={selectedOption4} onChange={handleTypeSelect4} style={{ border: 'none', width: '10rem'}}>
                                            <option value="">-- Seleccionar --</option>
                                            {options.map((option) => (
                                            <option key={option.value} value={option.value} id='first-column3'>
                                                {option.value}
                                            </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td style={{width: '20rem'}}>{descripcion4}</td>
                                    <td style={{width: '15rem'}}><input type="text" name="campo1" style={{ border: 'none', width: '4rem'}}/></td>
                                    <td style={{width: '15rem'}}><input type="text" name="campo1" style={{ border: 'none', width: '15rem' }}/></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                   <div className='row'>
                            <div className='col-6 d-none d-print-block' style={{ marginTop: '150px' }}>
                                <label className='d-flex justify-content-center'>......................................................................</label>
                                <label className='d-flex justify-content-center'>Firma</label>
                            </div>
                            {/* QR para acceder a la app del cliente */}
                            <div className='col-6 d-none d-print-block' style={{marginTop:'20px'}}>
                                <p className='d-flex justify-content-end' style={{margin:'0 0 0 0'}}>¡Hace el seguimiento desde la web!</p>
                                <div className='d-flex justify-content-end' style={{margin:'0 4.5rem 0 0'}} >
                                    <QRGenerator data={qrData}/>
                                </div>
                                <p className='d-flex justify-content-end'style={{margin:'0 0 0 0'}}>https://atencion.peabody.com.ar/</p>
                            </div>
                        </div>
            </div>
        </div>
    </div>
    </div>
    )
}
